import React from 'react'

export const AppContext = React.createContext({})

export const AppProvider = ({ children, ...props }) => <AppContext value={props}>{children}</AppContext>